export class BadgeService {

    public static updateBadgeStatus() {
        window.dispatchEvent(new CustomEvent('badge-redraw'));
    }
}
